import { PersonRelationType } from '@dealstack/shared/lib/generated';

export const CONTROLLING_PARTY_RELATION_TYPES = [
	PersonRelationType.DIRECTOR,
	PersonRelationType.UBO,
	PersonRelationType.PSC,
	PersonRelationType.TRUSTEE,
	PersonRelationType.SETTLER_OR_GRANTOR,
	PersonRelationType.PROTECTOR_OR_ENFORCER,
	PersonRelationType.BENEFICIARY,
	PersonRelationType.OTHER,
] as const;
